export default "__VITE_ASSET__Coh6xVvo__"